import { Pipe, PipeTransform } from 'angular-ts-decorators';

import { isEmpty, filter, isArray, isObject, isUndefined } from 'lodash';

export type ObjectLengthFilter = (input: Object) => number;

interface IObjectLength {
  transform: ObjectLengthFilter;
}

/**
 * Filter in the coreModule. returns the amount of keys in a object
 * @param {object} input object to be checked
 * @return {number} number of keys
 */
@Pipe({ name: 'objectLength' })
export class ObjectLengthPipe implements PipeTransform, IObjectLength {
  constructor() {
    'ngInject';
  }

  public transform(input: object): number {
    if (!angular.isObject(input)) {
      return 0;
    }

    return Object.keys(
      filter(input, (value) => {
        if (isObject(value) || isArray(value)) {
          return !isEmpty(value);
        }

        return !isUndefined(value);
      }),
    ).length;
  }
}
